module.exports = __webpack_public_path__ + "img/11.62826ba3.png";